<nav class="navbar fixed-top navbar-expand-lg site-nav">
  <div class="container-xxl site-nav-inner">
    <button class="site-brand" type="button" (click)="navigate('home')">
      <img src="assets/img/logo.png" alt="">
      <span class="site-brand-text">
        <span class="site-brand-name">Misericordia</span>
        <span class="site-brand-place">Borgo San Lorenzo</span>
      </span>
    </button>
    <button class="navbar-toggler custom-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" [attr.aria-label]="menuOpen ? 'Chiudi il menu' : 'Apri il menu'"
      (click)="menuOpen = !menuOpen">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto align-items-lg-center">
        @for (menu of (menuNavbar$ | async); track menu) {
          <li class="nav-item">
            @if (!menu.submenu) {
              <button class="nav-link site-link" type="button" [class.is-active]="isCurrentPage(menu.name)" (click)="navigate(menu.path)">
                <span>{{ menu.name }}</span>
              </button>
            } @else {
              <div class="dropdown d-none d-lg-block">
                <button class="site-link dropdown-toggle" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false" [class.is-active]="isCurrentPage(menu.name)">
                  {{ menu.name }}
                </button>
                <ul class="dropdown-menu site-dropdown">
                  @for (submenu of menu.submenu; track submenu) {
                    <li>
                      <button class="dropdown-item" type="button" (click)="navigate(submenu.path)"><span>{{ submenu.name }}</span></button>
                    </li>
                  }
                </ul>
              </div>
              <div class="mobile-group d-lg-none">
                <button class="site-link mobile-group-toggle" type="button" [class.is-open]="isGroupOpen(menu.name)"
                  [class.is-active]="isCurrentPage(menu.name)" [attr.aria-expanded]="isGroupOpen(menu.name)"
                  (click)="toggleGroup(menu.name)">
                  <span>{{ menu.name }}</span>
                  <i class="bi bi-chevron-down" aria-hidden="true"></i>
                </button>
                <div class="mobile-sub" [class.is-open]="isGroupOpen(menu.name)">
                  <div class="mobile-sub-inner" [attr.inert]="isGroupOpen(menu.name) ? null : ''">
                    @for (submenu of menu.submenu; track submenu.path) {
                      <button type="button" [class.is-active]="isCurrentPath(submenu.path)" (click)="navigate(submenu.path)"><span>{{ submenu.name }}</span></button>
                    }
                  </div>
                </div>
              </div>
            }
          </li>
        }
      </ul>

      @if (authService.isLoggedIn()) {
        <div class="d-none d-lg-block">
          <div class="dropdown">
            @if (user$ | async; as user) {
              <button type="button" class="account-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-person-fill"></i>
                <span>{{ user.name }}</span>
              </button>
            } @else {
              <button type="button" class="account-button" disabled>Loading...</button>
            }
            <ul class="dropdown-menu dropdown-menu-end site-dropdown">
              @for (menuUser of (menuUserNavbar$ | async); track menuUser) {
                <li>
                  <button class="dropdown-item" type="button" (click)="navigate(menuUser.path)"><span>{{ menuUser.name }}</span></button>
                </li>
              }
              <li>
                <button class="dropdown-item" type="button" (click)="logout()"><span>Esci</span></button>
              </li>
            </ul>
          </div>
        </div>
        <div class="d-lg-none mobile-account">
          @for (menuUser of (menuUserNavbar$ | async); track menuUser.path) {
            <button class="site-link" type="button" [class.is-active]="isCurrentPath(menuUser.path)" (click)="navigate(menuUser.path)"><span>{{ menuUser.name }}</span></button>
          }
          <button class="site-link" type="button" (click)="logout()"><span>Esci</span></button>
        </div>
      }
    </div>
  </div>
</nav>
